import { z } from 'zod';
import { DayOfWeek } from '@/services/api/petseo.client.wrapper';

const TIME_REGEX = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;

export const businessHoursSchema = z
  .object({
    dayOfWeek: z.nativeEnum(DayOfWeek, { message: 'Wybierz dzień tygodnia' }),
    is24Hours: z.boolean(),
    startTime: z.string().optional(),
    endTime: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.is24Hours) return;

    if (!data.startTime || !TIME_REGEX.test(data.startTime)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['startTime'],
        message: data.startTime ? 'Nieprawidłowy format godziny' : 'Godzina rozpoczęcia jest wymagana',
      });
    }

    if (!data.endTime || !TIME_REGEX.test(data.endTime)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['endTime'],
        message: data.endTime ? 'Nieprawidłowy format godziny' : 'Godzina zakończenia jest wymagana',
      });
      return;
    }

    if (data.startTime && TIME_REGEX.test(data.startTime)) {
      const [startHours = 0, startMinutes = 0] = data.startTime.split(':').map(Number);
      const [endHours = 0, endMinutes = 0] = data.endTime.split(':').map(Number);
      if (startHours * 60 + startMinutes >= endHours * 60 + endMinutes) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['endTime'],
          message: 'Godzina zakończenia musi być późniejsza niż rozpoczęcia',
        });
      }
    }
  });

export type BusinessHoursFormData = z.infer<typeof businessHoursSchema>;
